import { BoxProps } from '@jfs/ui-new'

const styles = {
  alert: {
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  freezeList: {
    position: 'sticky',
    left: 0,
    zIndex: 10,
    height: '100%',
    backgroundColor: 'white',
    margin: 0,
    padding: 0,
  } as unknown as BoxProps,
  DEFAULT: {
    container: {
      flex: 1,
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: 'SHADED_GREY',
      borderRadius: 4,
      zIndex: 4,
    } as BoxProps,
  },
  SIDE_MENU: {
    container: {
      flex: 1,
    } as BoxProps,
  },
  TABLE: {
    container: {
      flex: 1,
      borderColor: 'SECONDARY_GREY',
      borderWidth: 1,
      borderRadius: 4,
    } as BoxProps,
  },
  Block: {
    container: {
      flex: 1,
      borderColor: 'SECONDARY_GREY',
      borderWidth: 1,
      borderRadius: 4,
    } as BoxProps,
  },
  MENU_TITLE: {
    container: {
      flex: 1,
    } as BoxProps,
  },
  NOTIFICATION: {
    container: {
      flex: 1,
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: 'SHADED_GREY',
      borderRadius: 4,
      zIndex: 4,
    } as BoxProps,
  },

  Modes: {
    container: {
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: 'SHADED_GREY',
      borderRadius: 4,
      zIndex: 4,
    } as BoxProps,
  },
  SEARCH: {
    container: {
      flex: 1,
    } as BoxProps,
  },
  SEARCH_FILTERS: {
    container: {
      flex: 1,
    } as BoxProps,
  },
  INVOICE: {
    container: {
      flex: 1,
    } as BoxProps,
  },
}
export default styles
